<template>
  <label
    for="application-list_search"
    class="text-slate-700 font-semibold mb-2 inline-block"
    >Search</label
  >
  <input
    type="search"
    id="application-list_search"
    class="border-2 border-primary px-3 h-10 outline-none rounded-lg w-full"
    :defaultValue="defaultValue"
    @input="handleSearch($event)"
  />
</template>

<script setup>
import { onBeforeUnmount, ref } from "vue";

const props = defineProps({
  refine: {
    type: Function,
    required: true,
  },
  defaultValue: String,
});

const timeout = ref(null);

onBeforeUnmount(() => {
  if (timeout.value) {
    clearTimeout(timeout.value);
  }
});

const handleSearch = (event) => {
  const value = event.currentTarget.value;

  // Clear any existing timeout
  if (timeout.value) {
    clearTimeout(timeout.value);
  }

  // Set new timeout
  timeout.value = setTimeout(() => {
    props.refine(value);
  }, 400); // 400ms debounce delay
};
</script>
